var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-stat-item"},[_c('p',[_vm._v(_vm._s(_vm.text)+":")]),_c('span',[_vm._v(_vm._s(_vm.temp ? _vm.date : _vm.displayDate(_vm.date)))])])}
var staticRenderFns = []

export { render, staticRenderFns }